import {decorate, observable} from 'mobx';
import {faSitemap} from '@fortawesome/free-solid-svg-icons';
import {BaseModel} from './base';

export class Hierarchy extends BaseModel {
  static faIcon = faSitemap;

  searchableProperties = ['name'];

  populateAttributesFromStore(rootStore) {
    this.parent = rootStore.hierarchyStore.getById(this.parentId);
  }

  // required attribute for tree select
  get value() {
    return this.id;
  }

  // required attribute for tree select
  get title() {
    return this.name;
  }
}

decorate(Hierarchy, {
  id: observable,
  name: observable,
  sortOrder: observable,
  parent: observable,
  parentId: observable,
});
